var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-bolder text-success ml-2",on:{"click":function($event){$event.stopPropagation();return _vm.$router.push({ name: 'Adicionar Saldo' })}}},[_c('a',[_vm._v(_vm._s(_vm.currency))])])}
var staticRenderFns = []

export { render, staticRenderFns }